<template>
  <div>
    <el-row :gutter="15">
      <el-col>
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-quyu el-icon--left"></i>模板管理
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入模板名称" v-model="queryObj.name" size="small" class="query" style="float: left"
              clearable @change="() => {
                this.queryObj.pageNum = 1;
                loadRosteringTypeList();
              }
                ">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <a class="template-link" style="margin-right: 100px" @mouseover="setLinkStyle($event.target)"
              @mouseout="resetLinkStyle($event.target)" @click="downSample">报表模板样例.docx</a>
            <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right: 6px"
              @click="add_init">新增</el-button>
            <es-delete @del="delBatch()" type="button"></es-delete>
          </div>
          <el-table :data="pageData.list" ref="templateTable" border stripe size="mini" height="calc(100vh - 250px)"
            v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="name" label="模板名称"> </el-table-column>
            <el-table-column prop="tempFile" label="模板文件">
              <template slot-scope="scope">
                <a class="template-link" @mouseover="setLinkStyle($event.target)"
                  @mouseout="resetLinkStyle($event.target)" @click="downFile(scope.row)">{{
                    scope.row.tempFile == null
                    ? ""
                    : JSON.parse(scope.row.tempFile)[0].name
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
                    class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row)" type="icon" :key="scope.row.id"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="(cpage) => {
              this.queryObj.pageNum = cpage;
              this.loadRosteringTypeList();
            }
              ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible" @closed="() => this.$refs['templateTypeForm'].clearValidate()" width="600px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑模板管理
      </span>
      <el-form :model="templateInfo" :rules="rules" size="mini" label-position="right" label-width="150px"
        ref="templateTypeForm">
        <el-form-item prop="name" label="模板名称">
          <el-input v-model="templateInfo.name" placeholder="请输入模板名称" style="width: 200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="fileName" label="模板文件">
          <div style="display: flex">
            <el-input v-model="templateInfo.fileName" readonly style="width: 200px">
            </el-input>
            <el-upload :action="getUploadAction()" accept=".doc,.docx" :beforeUpload="beforeUpload"
              :headers="{ token: this.$store.getUser().token, platform: 'web' }" :show-file-list="false"
              :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
              :data="{ busCode: 'reportWord', type: 'files' }">
              <el-button style="margin-left: 20px" size="mini" type="primary">上传</el-button>
            </el-upload>

          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="loadRosteringTypeList(); editVisible = false;">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitRosteringType()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "templateManage",
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      templateInfo: {}, //模板信息
      rules: {
        //验证条件
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          { max: 50, message: "不能超过50个字符", trigger: "blur" },
        ],
        fileName: [
          { required: true, message: "请上传模板文件", trigger: "blur" },
          { max: 50, message: "不能超过50个字符", trigger: "blur" },
        ],
      },
      loading: false,
      saving: false,
      name: ""
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadRosteringTypeList();
    },
    //从后台查询区域列表
    loadRosteringTypeList () {
      this.loading = true;
      this.$ajax
        .get("/buss/template/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true;
      this.templateInfo = {};
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true;
      this.templateInfo = JSON.parse(JSON.stringify(row));
      this.templateInfo.fileName = JSON.parse(
        this.templateInfo.tempFile
      )[0].name;
      this.name = this.templateInfo.name
    },
    //保存区域信息
    submitRosteringType () {
      this.$refs["templateTypeForm"].validate((valid) => {
        if (valid) {
          let url = "/buss/template/add";
          if (this.templateInfo.id != null) {
            url = "/buss/template/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.templateInfo)
            .then((msg) => {
              this.saving = false;
              this.loadRosteringTypeList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除模板信息
    del (list) {
      let ids = [];
      if (list.id != null) {
        ids = [list.id];
        this.loadingFile = true;
        let row = JSON.parse(list.tempFile)[0];
        let s = row.url.indexOf("=");
        let e = row.url.length;
        let filename = row.url.substring(s + 1, e);
        //物理删除
        this.$ajax
          .post("/file/file/delete", { fileName: filename })
          .then((msg) => {
            console.log(msg);
          })
          .catch((err) => {
            this.loadingFile = false;
            this.$message.error(err);
          });

        if (ids.length > 0) {
          this.loading = true;
          this.$ajax
            .post("/buss/template/delete", { ids: ids })
            .then((msg) => {
              this.loading = false;
              this.$message.success(msg);
              this.queryObj.pageNum = 1; //删除之后，回到第一页
              this.loadRosteringTypeList();
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        }
      }
    },
    //批量删除
    delBatch () {
      let files = [];
      let ids = [];
      this.$refs["templateTable"].selection.forEach((ele) => {
        ids.push(ele.id);
        let row = JSON.parse(ele.tempFile)[0];
        let s = row.url.indexOf("=");
        let e = row.url.length;
        let filename = row.url.substring(s + 1, e);
        files.push(filename);
      });
      console.log(files);
      console.log(ids);
      if (ids.length > 0 && files.length > 0) {
        //物理删除
        this.$ajax
          .post("/file/file/deleteBatch", { files: files })
          .then((msg) => {
            console.log(msg);
          })
          .catch((err) => {
            this.loadingFile = false;
            this.$message.error(err);
          });
        this.loading = true;
        this.$ajax
          .post("/buss/template/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadRosteringTypeList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    beforeUpload (file) {
      const isDoc = file.type === "application/msword";
      const isDocx =
        file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isAllowed = isDoc || isDocx;
      if (!isAllowed) {
        this.$message.error("只能上传doc和docx文件");
        return isAllowed;
      }

      this.loadingFile = true;
      const sizeLimit = file.size / 1024 / 1024 > 50;
      if (sizeLimit) {
        this.loadingFile = false;
        this.$message.warning("上传文件大小不能超过 50MB!");
      }
      return !sizeLimit;
    },
    handleSuccess (response, file) {
      console.log(response, file);
      if (response.code == 200) {
        let tempFileList = new Array();
        let filename

        if (this.templateInfo.tempFile != null) {
          let row = JSON.parse(this.templateInfo.tempFile)[0];
          let s = row.url.indexOf("=");
          let e = row.url.length;
          filename = row.url.substring(s + 1, e);

          tempFileList = JSON.parse(this.templateInfo.tempFile);
        }
        let a = new Array();
        a.push({
          name: file.name,
          size: file.size,
          url: "/file/file/down?filename=" + response.msg,
        });
        tempFileList = a;
        this.templateInfo.tempFile = JSON.stringify(tempFileList);
        if (this.templateInfo.id != null) {

          //物理删除
          this.$ajax
            .post("/file/file/delete", { fileName: filename })
            .then(() => {
              this.$ajax
                .post("/buss/template/edit", { id: this.templateInfo.id, tempFile: this.templateInfo.tempFile, name: this.name })
                .then((msg) => {
                  /*if (this.templateInfo.tempFile != null) {
                  this.assetFileList = JSON.parse(this.templateInfo.tempFile);
                } else {
                  this.assetFileList = [];
                }*/
                  this.$message.success(msg);

                  this.loadingFile = false;
                })
                .catch((err) => {
                  this.$message.error(err);
                });
            })
            .catch((err) => {
              this.loadingFile = false;
              this.$message.error(err);
            });
        }
        this.$set(this.templateInfo, "fileName", file.name);
        //this.templateInfo.fileName=file.name
        this.$forceUpdate(); //强制更新组件
        this.$refs["templateTypeForm"].clearValidate(["fileName"]);
      } else {
        this.$message.error(response.msg);
      }
    },

    handleError () {
      this.loadingFile = false;
      this.$message.error("上传附件失败，请确认文件是否超出");
    },
    handleExceed () {
      this.$message.error("超出最大上传附件数");
    },

    downFile (row) {
      let list = JSON.parse(row.tempFile)[0];
      this.loadingFile = true;
      const x = new window.XMLHttpRequest();
      x.open(
        "GET",
        this.$api +
        list.url +
        "&platform=web&token=" +
        this.$store.getUser().token,
        true
      );
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = list.name;
        a.click();
        this.loadingFile = false;
      };
      x.send();
      this.loadingFile = false;
    },

    setLinkStyle (target) {
      target.style.color = "#409EFF";
      target.style.textDecoration = "underline";
      target.style.cursor = "pointer";
    },
    resetLinkStyle (target) {
      target.style.color = "";
      target.style.textDecoration = "none";
      target.style.cursor = "";
    },
    downSample () {
      var a = document.createElement('a')     // 创建一个<a></a>标签
      a.href = 'template.docx'         //重点（如测试发现下载文件不存在/找不到，检查路径）
      a.download = '报表模板样例'         // 设置下载文件文件名
      a.style.display = 'none'           // 隐藏a标签
      document.body.appendChild(a)       // 将a标签追加到文档对象中
      a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()
    },
    getUploadAction () {
      return this.$api + "/file/file/upload";
    },
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped>
.template-link {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
}

.template-link:hover {
  text-decoration: underline;
}
</style>
